import { jsPDF } from "jspdf";
import autoTable from "jspdf-autotable";
import { bankRowsAtTerm } from "./carLoan";

const money = (n) => `$${Math.round(n || 0).toLocaleString()}`;
const TEAL = [62, 150, 144];
const INK = [45, 55, 72];

export function downloadCarReportPdf({ report, contact, listingTitle, financed, termYears }) {
  const doc = new jsPDF();
  const landed = report.landed_cost || {};
  const rows = bankRowsAtTerm(report.bank_rows, financed, termYears);

  doc.setFillColor(...TEAL);
  doc.rect(0, 0, 210, 38, "F");
  doc.setTextColor(255, 255, 255);
  doc.setFont("helvetica", "bold");
  doc.setFontSize(22);
  doc.text("Financify", 15, 18);
  doc.setFontSize(11);
  doc.setFont("helvetica", "normal");
  doc.text("Car Pro Report", 15, 28);
  doc.text(new Date().toLocaleDateString(), 195, 28, { align: "right" });

  doc.setTextColor(...INK);
  doc.setFont("helvetica", "bold");
  doc.setFontSize(16);
  doc.text(report.headline || "Your car buying power", 15, 52);
  doc.setFont("helvetica", "normal");
  doc.setFontSize(10);
  doc.setTextColor(100, 100, 100);
  const prepared = `Prepared for ${contact.name || contact.email}${contact.email ? ` (${contact.email})` : ""}`;
  doc.text(prepared, 15, 60);
  if (listingTitle) doc.text(`Vehicle: ${listingTitle}`, 15, 66);
  doc.text(doc.splitTextToSize(report.summary || "", 180), 15, listingTitle ? 73 : 67);

  autoTable(doc, {
    startY: 84,
    head: [["Summary", ""]],
    body: [
      ["Car price range", `${money(report.max_car_price_low)} - ${money(report.max_car_price_high)}`],
      ["Est. monthly (longest term to 3 yrs)", `${money(report.est_monthly_payment_low)} - ${money(report.est_monthly_payment_high)}`],
      ["Amount financed", money(financed)],
      ["Chosen term", `${termYears} years`],
      ["Current TDSR", `${report.tdsr_pct}%`],
    ],
    theme: "plain",
    headStyles: { fillColor: TEAL, textColor: 255 },
    styles: { fontSize: 10, cellPadding: 3 },
    columnStyles: { 1: { halign: "right", fontStyle: "bold" } },
    margin: { left: 15, right: 15 },
  });

  if (landed.imported) {
    autoTable(doc, {
      startY: doc.lastAutoTable.finalY + 8,
      head: [["Itemized landed cost (estimate)", ""]],
      body: [
        ["Listing price", money(landed.listing_price)],
        [`Customs duty (${landed.customs_duty_pct}%)`, money(landed.customs_duty)],
        ["VAT (10%)", money(landed.vat)],
        ["Environmental levy", money(landed.env_levy)],
        ["Processing + stamp", money(landed.processing_stamp)],
        ["Freight (estimate)", money(landed.freight)],
        ["Total landed cost", money(landed.landed_total)],
      ],
      theme: "striped",
      headStyles: { fillColor: TEAL, textColor: 255 },
      styles: { fontSize: 10, cellPadding: 3 },
      columnStyles: { 1: { halign: "right" } },
      margin: { left: 15, right: 15 },
    });
  }

  autoTable(doc, {
    startY: doc.lastAutoTable.finalY + 8,
    head: [["Bank", "Rate", "Max term", "Max loan", `Monthly @ ${termYears} yrs`, "Monthly @ max term"]],
    body: rows.map((r) => [
      r.bank_name,
      `${r.rate}%`,
      `${r.term_years} yrs`,
      money(r.max_loan),
      `${money(r.chosen_monthly)}${r.capped ? ` (${r.chosen_years} yrs max)` : ""}`,
      money(r.est_monthly_payment),
    ]),
    theme: "striped",
    headStyles: { fillColor: TEAL, textColor: 255 },
    styles: { fontSize: 9, cellPadding: 3 },
    margin: { left: 15, right: 15 },
  });

  let y = doc.lastAutoTable.finalY + 10;
  if (y > 250) { doc.addPage(); y = 20; }
  doc.setTextColor(...INK);
  doc.setFont("helvetica", "bold");
  doc.setFontSize(12);
  doc.text("Next steps", 15, y);
  doc.setFont("helvetica", "normal");
  doc.setFontSize(10);
  y += 7;
  (report.next_steps || []).forEach((s, i) => {
    const lines = doc.splitTextToSize(`${i + 1}. ${s}`, 180);
    if (y + lines.length * 5 > 280) { doc.addPage(); y = 20; }
    doc.text(lines, 15, y);
    y += lines.length * 5 + 2;
  });

  doc.setFontSize(8);
  doc.setTextColor(140, 140, 140);
  const disc = doc.splitTextToSize(report.disclaimer || "", 180);
  if (y + disc.length * 4 > 285) { doc.addPage(); y = 20; }
  doc.text(disc, 15, y + 4);

  doc.save(`Financify-Car-Pro-Report-${(contact.name || "report").replace(/\s+/g, "-")}.pdf`);
}
